module.exports = __webpack_public_path__ + "img/award-bg.71b0bc20.png";